// @flow
import React from 'react'
import { Typography, Grid, Collapse } from '@material-ui/core'
import i18n from 'i18next'
import { Helmet } from 'react-helmet'

import { DAMM_RED } from '../../../../theme/colors.js'
import { getCategoryFromProductID } from '../../../../hardCodedData/services/getCategoryFromProductID.js'
import Link from '../../../../components/Link'
import Hamburger from '../Hamburger'
import CategoryList from './CategoryList'
import styles, { INFO_PANEL_FONT_SIZE, POWERED_BY_FONT_SIZE } from './styles.js'

type Props = {
  background: string,
  catalogID?: string,
  color: string,
  hardCodedProducts: Object,
  freeDeliveryMessage: boolean,
  isOpen: boolean,
  isAtHomePage: boolean,
  isPermanentlyOpen: boolean,
  links: Array<Object>,
  productID: number,
  staticPageID: string,
  toggleDrawer: Function,
  width: string
}

type State = {
  activeCategory: string
}

export class DrawerDesktop extends React.Component<Props, State> {
  constructor (props: Object) {
    super(props)
    const activeProductType = getCategoryFromProductID(props.productID)
    const activeCatalogId = props.catalogID === 'all' ? 'beer' : props.catalogID

    this.state = {
      activeCategory:
        activeProductType ||
        activeCatalogId ||
        (props.staticPageID && 'info') ||
        'beer'
    }
  }

  toggleActiveCategory: Function = (activeCategory: string) => {
    this.setState({
      activeCategory
    })
  }

  render () {
    const allProductsCatalogColor =
      this.props.catalogID === 'all' ? DAMM_RED : this.props.color

    return (
      <>
        <Helmet>
          <style>{`.hoverBold:hover { font-weight: bold}`}</style>
        </Helmet>
        {!this.props.isPermanentlyOpen && (
          <Grid onMouseEnter={this.props.toggleDrawer} style={styles.hamburger}>
            <Hamburger color={this.props.color} />
          </Grid>
        )}
        <div
          style={styles.drawerContainer(
            this.props.freeDeliveryMessage,
            this.props.background,
            this.props.isOpen,
            this.props.width,
            this.props.isAtHomePage
          )}
        >
          <div style={styles.drawerChild}>
            <div style={styles.seeAllProducts}>
              <Link
                to={i18n.t('routes.HOME')}
                style={styles.anchor(this.props.color)}
              >
                <Typography
                  style={styles.seeAllProductsText(allProductsCatalogColor)}
                >
                  {i18n.t(`catalog.seeEverything.all`)}
                </Typography>
              </Link>
            </div>
            {Object.keys(this.props.hardCodedProducts).map((category, idx) => (
              <CategoryList
                key={idx}
                color={this.props.color}
                activeCategory={this.state.activeCategory}
                toggleActiveCategory={this.toggleActiveCategory}
                productID={this.props.productID}
                products={this.props.hardCodedProducts[category]}
                category={category}
                catalogID={this.props.catalogID}
              />
            ))}

            <Typography
              onClick={() =>
                this.toggleActiveCategory(
                  this.state.activeCategory === 'info' ? 'none' : 'info'
                )
              }
              style={styles.info(this.props.color)}
            >
              +Info
            </Typography>
            <Collapse
              in={this.state.activeCategory === 'info'}
              style={styles.collapse}
            >
              {this.props.links.map((link, idx) =>
                link.target === '_blank' ? (
                  <a
                    href={i18n.t(link.link)}
                    style={styles.anchor(this.props.color)}
                    key={idx}
                    target={link.target}
                  >
                    <Typography
                      gutterBottom
                      style={styles.text(
                        this.props.staticPageID === link.pageSlug
                          ? DAMM_RED
                          : this.props.color,
                        INFO_PANEL_FONT_SIZE
                      )}
                      className='hoverBold'
                    >
                      {i18n.t(link.text)}
                    </Typography>
                  </a>
                ) : (
                  <Link
                    to={i18n.t(link.link)}
                    style={styles.anchor(this.props.color)}
                    key={idx}
                    target={link.target}
                  >
                    <Typography
                      gutterBottom
                      style={styles.text(
                        this.props.staticPageID === link.pageSlug
                          ? DAMM_RED
                          : this.props.color,
                        INFO_PANEL_FONT_SIZE
                      )}
                      className='hoverBold'
                    >
                      {i18n.t(link.text)}
                    </Typography>
                  </Link>
                )
              )}
              <Typography
                gutterBottom
                style={styles.text(this.props.color, INFO_PANEL_FONT_SIZE)}
              >
                {i18n.t('appshell.footer.customerService')} 900 373 183
              </Typography>
              <Typography
                gutterBottom
                style={styles.text(this.props.color, POWERED_BY_FONT_SIZE)}
              >
                Powered by
                <b>
                  <a
                    href='https://www.ulabox.com'
                    target={'_blank'}
                    style={styles.anchor(this.props.color)}
                  >
                    {' '}
                    ulabox.com
                  </a>
                  {i18n.t('appshell.footer.onlineSupermarket')}
                </b>
              </Typography>
            </Collapse>
          </div>
        </div>
      </>
    )
  }
}

export default DrawerDesktop
